<app-auth-layout>
  <app-sign-in-form></app-sign-in-form>
</app-auth-layout>
